// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"5e0e29a1","977":"cfd808ab"}[chunkId] + ".chunk.js";
};